import { useState, useCallback } from "react";

interface StudySession {
  classId: number;
  classTitle: string;
  durationMs: number;
  dateMs: number;
}

interface StudyTimeStore {
  totalMs: number;
  sessions: StudySession[];
}

const DEFAULT: StudyTimeStore = { totalMs: 0, sessions: [] };

function load(): StudyTimeStore {
  try {
    const raw = localStorage.getItem("growseo_study_time");
    if (raw) return { ...DEFAULT, ...JSON.parse(raw) };
  } catch (e) {
    console.warn("StudyTimeStore load error", e);
  }
  return DEFAULT;
}

function save(s: StudyTimeStore) {
  try {
    localStorage.setItem("growseo_study_time", JSON.stringify(s));
  } catch (e) {
    console.warn("StudyTimeStore save error", e);
  }
}

export function formatStudyTime(ms: number): string {
  const totalMin = Math.floor(ms / 60000);
  const hours = Math.floor(totalMin / 60);
  const mins = totalMin % 60;
  if (hours === 0) return `${mins}분`;
  return `${hours}시간 ${mins > 0 ? `${mins}분` : ""}`.trim();
}

export function useStudyTimeStore() {
  const [data, setData] = useState<StudyTimeStore>(load);

  const addSession = useCallback((classId: number, classTitle: string, durationMs: number) => {
    if (durationMs < 60000) return; // ignore < 1 minute
    setData((prev) => {
      const session: StudySession = { classId, classTitle, durationMs, dateMs: Date.now() };
      const next: StudyTimeStore = {
        totalMs: prev.totalMs + durationMs,
        sessions: [session, ...prev.sessions.slice(0, 49)],
      };
      save(next);
      return next;
    });
  }, []);

  return { totalMs: data.totalMs, sessions: data.sessions, addSession };
}
